import { render, staticRenderFns } from "./CRMCreateView.vue?vue&type=template&id=2661ce6e&scoped=true"
import script from "./CRMCreateView.vue?vue&type=script&lang=js"
export * from "./CRMCreateView.vue?vue&type=script&lang=js"
import style0 from "./CRMCreateView.vue?vue&type=style&index=0&id=2661ce6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2661ce6e",
  null
  
)

export default component.exports